import Vue from 'vue'
import { formatPrice } from 'lib/util'

Vue.filter('formatPrice', function (value, withCurrency = false, fraction = 0) {
  if (!value) return ''
  return `${withCurrency ? '$' : ''}${formatPrice(value, fraction)}`
})

Vue.filter('currency', function (value, decimals = 0) {
  if (isNaN(parseFloat(value))) return value
  var currency = '$'
  value = parseFloat(value)
  if (value < 0) var sign = '-'
  else sign = ''
  return `${sign}${currency}${Math.abs(value).toFixed(decimals)}`
})

Vue.filter('crop', function (imageUrl, width, height, factor = 2) {
  var w = width * factor
  var h = height * factor
  return imageUrl.replace(/(\.[^.]+)$/, `_${w}x${h}$1`)
})
